import { useState, useEffect } from 'react'
import '../styles/StatusDisplay.css'

// Only show for critical status changes, not routine connection steps
const BIG_CHANGES = [
  'Connection failed',
  'Authentication required',
  'Authentication error',
  'Disconnected',
  'please refresh'
]

function StatusDisplay({ status }) {
  const [visible, setVisible] = useState(false)

  const isBigChange = BIG_CHANGES.some(s => status.includes(s))
  const isDebug = import.meta.env.VITE_DEBUG_MODE === 'true'

  useEffect(() => {
    if (!isBigChange && !isDebug) {
      setVisible(false)
      return
    }
    setVisible(true)
    const timer = setTimeout(() => setVisible(false), 5000)
    return () => clearTimeout(timer)
  }, [status, isBigChange, isDebug])

  if (!visible) return null

  return (
    <div className="status-display">
      {status}
    </div>
  )
}

export default StatusDisplay